export const waLink = (number, message) => {
  const clean = (number || "").replace(/\D/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(message || "")}`;
};

export const formatBRL = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const n = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(n)) return String(value);
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const isExpired = (dateStr) => {
  if (!dateStr) return false;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d < today;
};

// Resolve the contact URL for a product: its own free link (normalized), or the store WhatsApp as fallback.
export const productContact = (p, store) => {
  const raw = (p?.contact_link || "").trim();
  if (raw) {
    if (/^(https?:|mailto:|tel:)/i.test(raw)) return raw;
    return `https://${raw}`;
  }
  if (store?.whatsapp) {
    return waLink(store.whatsapp, `Olá! Vi o produto ${p?.name || ""} no Divulga Pocinhos Guia e tenho interesse.`);
  }
  return "";
};


const normalizeLink = (raw) => (/^(https?:|mailto:|tel:)/i.test(raw) ? raw : `https://${raw}`);

export const promoWhatsApp = (p, business) => {
  const number = (p?.whatsapp || "").trim() || business?.whatsapp;
  if (!number) return "";
  const msg = (p?.wa_message || "").trim() || `Olá! Vi a promoção "${p?.title || ""}" no Divulga Pocinhos Guia e tenho interesse.`;
  return waLink(number, msg);
};

export const reelContact = (r, business) => {
  const raw = (r?.button_link || "").trim();
  if (raw) return normalizeLink(raw);
  if (business?.whatsapp) return waLink(business.whatsapp, `Olá! Vi o vídeo "${r?.title || ""}" no Divulga Pocinhos Guia.`);
  return "";
};

export const REWARD_DEFAULTS = {
  active: false, button_label: "Ganhe prêmio", title: "Poste nos Stories e ganhe",
  amount: 0, rules: "", instagram: "", cta_text: "Abrir meu Instagram",
};

export const instaHandle = (raw) => (raw || "").trim().replace(/^https?:\/\/(www\.)?instagram\.com\//i, "").replace(/^@/, "").replace(/\/.*$/, "");
export const instaUrl = (raw) => (instaHandle(raw) ? `https://instagram.com/${instaHandle(raw)}` : "");

export const couponTypeLabel = (type, value) => {
  switch (type) {
    case "percent":
      return `${value}% OFF`;
    case "value":
      return `R$ ${value} OFF`;
    case "free_shipping":
      return "Frete Grátis";
    default:
      return "Oferta";
  }
};
